import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { StoriesSubSlider } from "../StoriesSubSlider/StoriesSubSlider";

import { SwiperOptions } from "swiper/types/swiper-options";

import { useStoriesProviderData } from "../../../providers/storiesProvider";
import { IonIcon } from "@ionic/react";
import { chevronBack, chevronForward } from "ionicons/icons";
import { Pagination } from "swiper/modules";
import { Swiper as SwiperClass } from "swiper/types";

import styles from "./StoriesSlider.module.scss";
import "./StoriesSlider.scss";

import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const storiesSliderConf: SwiperOptions = {
  pagination: false,
  spaceBetween: 0,
  autoplay: false,
  loop: false,
  allowTouchMove: false,
};

let touchDelay = 300;

const StoriesSlider = () => {
  const {
    toggleSliderPlaying,
    slideToNextBtnHandler,
    slideToPrevBtnHandler,
    setParentSlider,
    parentSliderActiveIndex,
    slidesData,
    isSliderLoading,
  } = useStoriesProviderData();
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

  const touchStart = () => {
    if (isSliderLoading || timer) return;

    const newTimer = setTimeout(() => {
      toggleSliderPlaying();
    }, touchDelay);
    setTimer(newTimer);
  };

  const touchEnd = () => {
    if (isSliderLoading) return;

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
      return;
    }

    toggleSliderPlaying();
  };

  const nextButtonHandler = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    slideToNextBtnHandler();
  };

  const prevButtonHandler = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    slideToPrevBtnHandler();
  };

  useEffect(() => {
    if (!!swiper) {
      setParentSlider(swiper);
    }
  }, [swiper]);

  return (
    <>
      <div className={cx("navigation")}>
        <div className={cx("navigation__left")} onClick={prevButtonHandler}>
          <IonIcon icon={chevronBack} className={cx("navigation__icon")} />
        </div>
        <div className={cx("navigation__right")} onClick={nextButtonHandler}>
          <IonIcon icon={chevronForward} className={cx("navigation__icon")} />
        </div>
      </div>
      <div className={cx("buttons")} onTouchStart={touchStart} onTouchEnd={touchEnd}>
        <div className={`nextButton ${cx("nextButton")}`} onClick={nextButtonHandler}></div>
        <div className={`prevButton ${cx("prevButton")}`} onClick={prevButtonHandler}></div>
      </div>
      <Swiper
        onInit={(swiper: SwiperClass) => {
          setSwiper(swiper);
        }}
        initialSlide={parentSliderActiveIndex}
        className={`parent-slider swiper-h ${cx("slider")}`}
        modules={[Pagination]}
        {...storiesSliderConf}
      >
        {slidesData.map((slides, key) => {
          return (
            <SwiperSlide key={key}>
              <StoriesSubSlider subIndex={key} slides={slides} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export { StoriesSlider };
